import React, { useState } from 'react'
import { UserType } from '../types/user-types';
import axiosInstance from '../utils/axios-instance';
import { toast } from "sonner";

const AddUser = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        userType: UserType.USER, // Default value
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validate = () => {
        const validationErrors = {};

        // Full name validation
        if (!formData.fullName) {
            validationErrors.fullName = 'Full name is required.';
        }

        // Email validation
        if (!formData.email) {
            validationErrors.email = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            validationErrors.email = 'Invalid email format.';
        }

        // User Type validation
        if (!Object.values(UserType).includes(Number(formData.userType))) {
            validationErrors.userType = 'Invalid user type.';
        }

        setErrors(validationErrors);

        // If there are validation errors, return false
        return Object.keys(validationErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);

        try {
            const res = await axiosInstance.post('/user/create', formData);
            if (res.status === 200) {
                toast.success(res.data.message);
                //result formdata
                setFormData({
                    fullName: '',
                    email: '',
                    userType: UserType.USER, // Reset to default value
                });
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            // console.error(error.response.data.message); 
            toast.error(error.response.data.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='mx-auto w-[85%] max-w-lg p-6 bg-white shadow-md rounded-lg'>
            <h1 className="text-2xl font-bold mb-4">Add New User</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="fullName" className="block text-sm font-medium text-gray-700">
                        Full Name
                    </label>
                    <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border ${errors.fullName ? 'border-red-500' : 'border-gray-300'
                            } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {errors.fullName && <p className="text-red-500 text-xs">{errors.fullName}</p>}
                </div>
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                        Email
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'
                            } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
                </div>
                <div>
                    <label htmlFor="userType" className="block text-sm font-medium text-gray-700">
                        User Type
                    </label>
                    <select
                        id="userType"
                        name="userType"
                        value={formData.userType}
                        onChange={handleChange}
                        className={`w-full px-3 py-2 border ${errors.UserType ? 'border-red-500' : 'border-gray-300'
                            } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                        <option value={UserType.ADMIN}>Admin</option>
                        <option value={UserType.FACILITATOR}>Facilitator</option>
                        <option value={UserType.USER}>User</option>
                    </select>
                    {errors.userType && <p className="text-red-500 text-xs">{errors.userType}</p>}
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    className="mt-4 w-full bg-brandPrimary text-white py-2 rounded-md"
                >
                    {loading ? 'Submitting...' : 'Create User'}
                </button>
            </form>
        </div>
    );
}

export default AddUser